<script setup lang="ts">
import { useCvButtonNavigation } from '../useCvButtonNavigation';
import NuxtLinkFlat from 'theme/components/atoms/NuxtLinkFlat.vue';

const { cvButtonTo } = useCvButtonNavigation();
</script>

<template>
  <NuxtLinkFlat :class="$style.cvButton" :to="cvButtonTo" variant="conversion"
    ><span :class="$style.cvButton__label">無料</span
    >診断をはじめる</NuxtLinkFlat
  >
</template>

<style lang="scss" module>
.cvButton {
  $root: &;

  display: inline-flex;
  align-items: center;
  font-size: 22px;
  padding: 0.5em 1.2em 0.55em;

  @include small-mobile-only {
    font-size: 18px;
  }

  @include tablet-upper {
    font-size: 28px;
  }

  &__label {
    padding: 6px 12px 5px;
    margin-right: 10px;
    color: #ff5e00;
    background-color: $color-surface-primary;
    border-radius: 9999em;
    font-size: 16px;
    line-height: 1;
    text-align: center;
    letter-spacing: 0.2em;
    text-indent: 0.2em;
  }
}
</style>
